import React from 'react';
import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';
import { FormattedMessage } from 'i18n';
import arrowDash from 'static/icons/arrow-dash-connected.svg';
import AddBrandToUrl from '../../utils/AddBrandToUrl';

function FAQButtonComponent({ language, airlineWhitelabel, brandName }) {
  const _language = language !== 'en' ? language : 'en-gb';
  let _href = `https://help.tripx.se/hc/${_language}/`;
  //FIND BETTER SOLUTION FOR THIS
  if (airlineWhitelabel) {
    _href = _href + `?brand=${airlineWhitelabel.brand}`;
  } else {
    _href = AddBrandToUrl(_href, brandName);
  }

  return (
    <a href={_href} target='_blank' rel='noopener noreferrer'>
      <SeeAllFAQ>
        <FormattedMessage
          id={'customerService.seeAllFaq.label'}
          description={'See all FAQ'}
          defaultMessage={'See all FAQ'}
        />
        <Margin inline right='1' />
        <img src={arrowDash} alt='' />
      </SeeAllFAQ>
    </a>
  );
}

export default FAQButtonComponent;

const SeeAllFAQ = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 213px;
  padding: 15px;
  background-color: ${({ theme }) => theme.colors.buttons.background || theme.colors.secondary.default};
  border: none;
  border-radius: 4px;
  font-size: 20px;
  color: ${({ theme }) => theme.colors.text.white};
  cursor: pointer;
`;
